import type { MouseEvent, ReactNode} from 'react';
import { useCallback } from 'react';
import Icon from './Icon';
import * as style from './PageHeading.module.css';

export interface Props {
    heading?: string;
    subHeading?: ReactNode;
    backHref?: string;
}

export default function PageHeading({ heading, subHeading, backHref }: Props) {
    return (
        <div className={style.pageHeading}>
            <div className={style.pageHeadingTopRow}>
                {backHref && <BackLink href={backHref} />}
                {heading && <h1>{heading}</h1>}
            </div>
            {subHeading && <span className={style.pageSubHeader}>{subHeading}</span>}
        </div>
    );
}

function BackLink({ href }: { href: string }) {
    const maybeGoBack = useCallback(
        (e: MouseEvent) => {
            try {
                const a = new URL(document.referrer);
                const b = new URL(href, document.location.href);

                if (history.state === null && a.pathname === b.pathname && a.search === b.search) {
                    history.back();
                    e.preventDefault();
                }
            } catch (e) {
                console.log(e);
                // do the default
            }
        },
        [href],
    );

    return (
        <a className={style.pageBackLink} href={href} onClick={maybeGoBack}>
            <Icon className="icon-chevron-left" renderWithSpan />
            Tilbake
        </a>
    );
}
